import Button from "@/components/Button/index";
import Modal from "@/dsComponents/Modal";
import { Checkbox, ModalBody, ModalFooter, ModalFooterRight, ModalHeader, ModalTitle } from "@dextech-ai/dex-design-system";
import { ArrowCircleUpOutlined } from "@dextech-ai/dex-design-system/icons";
import rem from '@/utils/rem';
import { useEffect, useState } from 'react';

const AgentPrincipalTnCModal = ({ visible, hide, acceptParticipantTnc, onCancel, onAccept, loading }) => {

	const [checkedParticipantsTncModal, setCheckedParticipantsTncModal] = useState(false)

	useEffect(() => {
		if (!visible) {
			setCheckedParticipantsTncModal(false)
		}
	}, [visible])

	function handledCheckedParticipantTnc() {
		setCheckedParticipantsTncModal(!checkedParticipantsTncModal)
	}

	return (
		<Modal visible={visible} size="large" close={hide} dismissClickOutsideModal={false}>
			<ModalHeader icon={<ArrowCircleUpOutlined data-ds-color="primary-dark" />}>
				<ModalTitle>Terms and Conditions for Agent-Principal Functionality</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<div>
					<div className="eap-modal__content">
						<p>
							The feature enables your pitstop to act as an intermediary for your Principals (users), managing their data access requirements. As an Agent, your role involves ensuring that data access and management align with the needs and expectations of your Principals.
						</p>
						<br />
						<p>
							By accessing or using this functionality, you confirm that you are authorised to share or receive Shared Data on behalf of the Principal. You further acknowledge and agree that any sharing or receipt of Shared Data shall comply with applicable laws.
						</p>
						<br />
						<p>
							You shall only use the Shared Data for the specific purpose for which it was provided by your Principal. Any other use requires explicit consent from the Principal or as permitted by applicable laws.
						</p>
						<br />
						<p>
							You shall be solely responsible for any misuse or unauthorised sharing or receipt of Shared Data, and agree to indemnify and hold harmless the Company from and against any loss or claim suffered by the Company arising out of or in connection with this service.
						</p>
					</div>
					<div className="tnc-modal__agree-content">
						<Checkbox
							checked={checkedParticipantsTncModal}
							onCheckedChange={handledCheckedParticipantTnc}
							data-testid="agent-principal-tnc-checkbox"
						>
							I have read and accepted the T&Cs
						</Checkbox>
					</div>
				</div>
			</ModalBody>
			<ModalFooter>
				<ModalFooterRight>
					<div className='tnc-modal__confirmation_actions'>
						<Button data-testid="agent-principal-tnc-decline" ghost round addClass="eap-modal__transButton" submit={() => hide()} text="Decline" />
						<Button data-testid="agent-principal-tnc-agree" full round maxWidth="100" submit={() => acceptParticipantTnc()} disabled={!checkedParticipantsTncModal} text="Agree" />
					</div>
				</ModalFooterRight>
			</ModalFooter>
		</Modal>
	)
};

export default AgentPrincipalTnCModal;
